import * as React from 'react';

import type { QueryResult } from '@apollo/client';

import type { NotificationResponse } from 'common/components/NotificationsWidget/queries';

import type { SourceHelpers } from '../Source';
import Source from '../Source';
import type { SubscribedNotificationsResponse } from './queries';
import { getSubscribedNotifications } from './queries';
import { subscribedNotificationCreated, subscribedNotificationUpdated } from './subscriptions';

export interface SubscribedNotificationSourceProps {
  children: (
    entities: NotificationResponse[],
    helpers: SourceHelpers<NotificationResponse>,
    queryResult: QueryResult<SubscribedNotificationsResponse>
  ) => React.ReactNode;
}

class SubscribedNotificationSource extends React.PureComponent<SubscribedNotificationSourceProps> {
  handleNotificationUpdated = (
    currState: NotificationResponse,
    prevState: NotificationResponse,
    helpers: SourceHelpers<NotificationResponse>
  ) => {
    if (currState.acknowledged && !prevState.acknowledged) {
      helpers.deleteFromStore(currState);
    }
  };
  selectEntityId = (notification: NotificationResponse) => notification.id;
  selectSyncOn = (notification: NotificationResponse) => new Date(notification.updatedAt);
  selectEntities = (response?: SubscribedNotificationsResponse) => response?.me?.notifications || [];
  selectStaleEntities = (response?: SubscribedNotificationsResponse) => response?.me?.sync || [];

  render() {
    return (
      <Source<NotificationResponse, SubscribedNotificationsResponse>
        name="SubscribedNotificationSource"
        onEntityUpdated={this.handleNotificationUpdated}
        selectEntities={this.selectEntities}
        selectStaleEntities={this.selectStaleEntities}
        selectEntityId={this.selectEntityId}
        selectSyncOn={this.selectSyncOn}
        query={getSubscribedNotifications}
        subscriptions={{
          create: [{ query: subscribedNotificationCreated }],
          update: { query: subscribedNotificationUpdated },
        }}
      >
        {(entities, helpers, queryResult) => this.props.children(entities, helpers, queryResult)}
      </Source>
    );
  }
}

export default SubscribedNotificationSource;
